import { defineAsyncComponent } from 'vue'
export default {
  "dark-quiz": defineAsyncComponent(() => import("/vercel/path0/layouts/dark-quiz.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/vercel/path0/layouts/empty.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/vercel/path0/layouts/main.vue").then(m => m.default || m)),
  "start-layout": defineAsyncComponent(() => import("/vercel/path0/layouts/start-layout.vue").then(m => m.default || m)),
  upsale: defineAsyncComponent(() => import("/vercel/path0/layouts/upsale.vue").then(m => m.default || m)),
  "white-quiz": defineAsyncComponent(() => import("/vercel/path0/layouts/white-quiz.vue").then(m => m.default || m))
}